export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";